import { useMemo, useState } from 'react';

type DropdownType = 'date' | 'time';

type Return = {
  isDateDropdownOpen: boolean;
  isTimeDropdownOpen: boolean;
  openDateDropdown: () => void;
  openTimeDropdown: () => void;
  closeDateDropdown: () => void;
  closeTimeDropdown: () => void;
};

export const useDateTimePickerFieldDropdownStatus = (): Return => {
  const [opendDropdown, setOpendDropdown] = useState<
    DropdownType | undefined
  >();

  return useMemo(() => {
    return {
      isDateDropdownOpen: opendDropdown === 'date',
      isTimeDropdownOpen: opendDropdown === 'time',
      openDateDropdown: () => setOpendDropdown('date'),
      openTimeDropdown: () => setOpendDropdown('time'),
      closeDateDropdown: () => setOpendDropdown(undefined),
      closeTimeDropdown: () => setOpendDropdown(undefined),
    };
  }, [opendDropdown]);
};
